import {GetMeAction} from '@possible/cassandra'
import {SmartSelectorFactory} from 'src/cassandra/src/utils'

export const useUser = SmartSelectorFactory(
  (state) => state.user,
  () => GetMeAction(),
  true,
)
